<script setup>
import { distance } from "vmap";

const props = defineProps(["pos", "site"]);
defineEmits(["close"]);

const numbFmt = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const distFmt = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const dist = distance(props.pos, [props.site.lng, props.site.lat]);
</script>

<template>
	<UiDialog class="site-info" @close="$emit('close')">
		<h1>{{ site.addr }}</h1>
		<div class="info">
			<div>{{ numbFmt.format(site.price_el / 80) }} <i>kr/kWh</i></div>
			<div>{{ numbFmt.format(site.price_park / 80) }} <i>kr/time</i></div>
			<div>{{ site.available }} <i>ledige</i></div>
			<div><img class="icon-location-dot"> {{ distFmt.format(dist / 1000) }} <i>km</i></div>
		</div>
	</UiDialog>
</template>
